import React, { useState } from "react";
import { 
    CircleCheck,
    Clock,
    Mail,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import NewItemButton from "components/button/NewItemButton";
import MessageTicket from "./components/MessageTicket";
import EmployeeInboxTabs from "./components/InboxTab";
import DepartmentGridCard from "./components/DepartmentCardGrid";
import { messages } from "./components/Messages";

const EmployeeInbox = () => {
    const [selectedDepartment, setSelectedDepartment] = useState("All");

    const total = messages.length;
    const pending = messages.filter(m => m.priority === "pending").length;
    const resolved = messages.filter(m => m.priority === "resolved").length;

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"My Inbox"}
                    icon={Mail}
                    description={"Connect with Hyvid departments for support and assistance"}
                    color={"bg-emerald"}
                    rightNav={
                        <NewItemButton
                            label="New Message"
                            bgColor="bg-white/20"
                            textColor="text-white" 
                            hoverBgColor="hover:bg-white/30 backdrop-blur-sm"
                        >
                            <MessageTicket />
                        </NewItemButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Total Messages"
                            icon={<Mail />}
                            display={total}
                        />
                        <SummaryItem
                            title="Pending"
                            icon={<Clock />}
                            display={pending} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved}
                        />
                   </div>
                </SummaryHeader>
                <DepartmentGridCard 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                    onSelectDepartment={setSelectedDepartment}
                />
                <EmployeeInboxTabs 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                />
            </div>
        </div>
    )
};
export default EmployeeInbox;